/*
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'../DashboardTemplatesAPI',
	'../../../../../lib/@waca/dashboard-common/dist/core/APIFactory'
], (DashboardTemplatesAPI, APIFactory) => {
	class DashboardTemplatesImpl {

		constructor(options) {
			this._logger = options.logger;
			this._getContentSvc = options.getContentSvc;
			this._featureChecker = options.featureChecker;

			this._isEnabled = !this._featureChecker.checkValue('dashboard', 'dashboardTemplates', 'disabled');
		}

		destroy() { }

		getAPI() {
			return APIFactory.createAPI(this, [DashboardTemplatesAPI]);
		}

		listTemplates() {
			if (!this._isEnabled) {
				return Promise.resolve([]);
			}

			return this._getContentSvc.then((contentSvc) => {
				const url = 'v1/search/cm?filter=type%7Cexploration&filter=tags%7Cdashboard_template';
				const options = {
					type: 'GET',
					data: {
						'fields': 'defaultName,data,id,ancestors,modificationTime'
					}
				};

				return contentSvc.get(url, options).then((response) => {
					const results = response && response.results;
					if (!results) {
						return [];
					}

					results.sort((a, b) => {
						return Date.parse(b.modificationTime) - Date.parse(a.modificationTime);
					}).forEach(template => {
						template.location = contentSvc.getLocation(template);
					});

					return results;
				}).catch(error => {
					this._logger.error(error, this);
					return [];
				});
			});
		}

		getTemplate(id, includeSpec) {
			if (!this._isEnabled) {
				return Promise.resolve({});
			}

			return this._getContentSvc.then((contentSvc) => {
				const url = contentSvc.getBaseObjectsURL() + '/' + id;
				const options = {
					dataType: 'json',
					type: 'GET'
				};
				if (includeSpec) {
					options.data = {
						fields: 'specification'
					};
				}
				return contentSvc.get(url, options).then((response) => {
					const result = response && response.data && response.data.length && response.data[0];
					if (result.specification) {
						try {
							result.specification = JSON.parse(result.specification);
						} catch (e) {
							return Promise.reject(e);
						}
					}
					return result;
				});
			});
		}

		getThumbnail(id) {
			if (!this._isEnabled) {
				return Promise.resolve({});
			}

			return this._getContentSvc.then((contentSvc) => {
				const url = contentSvc.getBaseObjectsURL() + '/' + id + '/items?types=graphic';
				const options = {
					type: 'GET',
					data: {
						'fields': 'data'
					}
				};
				return contentSvc.get(url, options).then((response) => {
					const result = response && response.data && response.data.length && response.data[0].data;
					return result;
				});
			});
		}
	}

	return DashboardTemplatesImpl;
});
